import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getRides, RidesQueryParams } from '../api/services/Rides';
import { RideListItem } from '../types/rides';

export const useRidesQuery = (queryParams: RidesQueryParams) => {
  return useApiGet<{ data: RideListItem[]; meta: Meta }>(
    ['ridesList', queryParams.page, queryParams.userId],
    () => getRides(queryParams),
    {
      enabled: true,
      placeholderData: (previousData) => ({
        data: {
          meta: {
            pageCount: Math.ceil(
              (previousData?.data?.meta?.totalCount || 0) / (previousData?.data?.meta?.perPage || 1)
            ),
          },
        },
      }),
    }
  );
};
